import { createApp } from 'vue'
import App from './App.vue'

import ElementPlus, { ElLoading } from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

const app = createApp(App)
app.use(ElementPlus, { locale: zhCn })
app.use(ElLoading)
app.mount('#app')
